import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { NewsItemType } from '../types/types';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import CarouselItem from './CarouselItem';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
type NewsCarouselProps = {
    items?: NewsItemType[];
};

const NewsCarousel: React.FC<NewsCarouselProps> = ({ items = [] }) => {
    return (
        <Swiper
            modules={[Navigation, Pagination]}
            navigation
            autoplay={{delay: 2000}}
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            loop={true}
            breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
              }}
        >
        {items.map((item, i) => (
            <SwiperSlide key={item.news_id}>
                <CarouselItem
                    link={item.news_link}
                    title={item.news_title}
                    date={item.created_at}
                    image_src={item.news_cover_path} />
            </SwiperSlide>
            ))}
      </Swiper>
    );
};

export default NewsCarousel;